import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { QuickPayPageRoutingModule } from './quick-pay-routing.module';

import { QuickPayPage } from './quick-pay.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    QuickPayPageRoutingModule
  ],
  declarations: [QuickPayPage]
})
export class QuickPayPageModule {}
